import { FormComponent } from '../components/form/form.component';
import { StepComponent } from '../components/step/step.component';
import { UnknownFormTypeComponent } from '../components/unknown-form-type/unknown-form-type.component';
import { FormType } from '../enums/form-type';
import { formType } from '../interfaces/form-type';

export const formTypeComponent: formType = {
  [FormType.FORM]: FormComponent,
  [FormType.STEP]: StepComponent,
  [FormType.UNKNOWN]: UnknownFormTypeComponent,
};
